import './App.css';
import Home from './pages/Home.js';
import Game from './pages/Game.js';
import SinglePlayerGame from './pages/SinglePlayerGame.js'
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom';

import io from 'socket.io-client';

// Backend URL from env (see Client/.env.example); defaults to localhost.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const socket = io.connect(BACKEND_URL, { transports : ['websocket'] });

function App() {
  
  return (
    <Router >
    <div className="App">
        <Redirect exact from="/" to="/home" />
        <Switch>
          <Route path="/home"> <Home socket={socket}/> </Route>
          <Route exact path="/game/:id"> <Game socket={socket}/> </Route>
          <Route path="/single_player"> < SinglePlayerGame /> </Route>
        </Switch>
    </div>
    </Router>
  );
}

export default App;
